import { useMemo } from 'react';

export interface UseProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export const useProgressBar = ({ currentStep, totalSteps }: UseProgressBarProps) => {
  // Calcular el progreso como porcentaje
  const progress = useMemo(() => {
    return Math.round((currentStep / totalSteps) * 100);
  }, [currentStep, totalSteps]);

  // Validar que los pasos sean válidos
  const isValidStep = useMemo(() => {
    return currentStep > 0 && currentStep <= totalSteps && totalSteps > 0;
  }, [currentStep, totalSteps]);

  // Obtener el progreso normalizado (0-100)
  const normalizedProgress = useMemo(() => {
    if (!isValidStep) return 0;
    return Math.min(Math.max(progress, 0), 100);
  }, [progress, isValidStep]);

  return {
    progress: normalizedProgress,
    isValidStep,
    currentStep,
    totalSteps,
  };
};
